import { ProjectParameter } from '@deltek/specification-client/core/Models/projectParameter'

const SUSTAINABILITY_TYPE_PARAM = 'Sustainability Type'
const SUSTAINABILITY_LABEL = 'Sustainability'

export const availableProjectParamters = [
    { name: 'Building Type', label: 'Building Type', multiple: false },
    { name: 'Contract Type', label: 'Contract Type', multiple: true },
    { name: 'Construction Type', label: 'Construction Type', multiple: false },
    {
        name: SUSTAINABILITY_TYPE_PARAM,
        label: SUSTAINABILITY_LABEL,
        multiple: false,
    },
    { name: 'Owner Type', label: 'Owner', multiple: false },
    { name: 'Geographic Region', label: 'Geographic Region', multiple: false },
    { name: 'Seismic Zone', label: 'Seismic Zone', multiple: false },
    { name: 'Wind Zone', label: 'Wind Zone', multiple: false },
]

/**
 * Determines whether this parameter allows multiple selections.
 * Sustainability is always multi-select; everything else uses its own `multiple` setting.
 */
export const isParameterMultiSelect = (parameter: {
    name: string
    multiple: boolean
}): boolean => {
    const isSustainability = parameter.name === SUSTAINABILITY_LABEL
    return isSustainability ? true : parameter.multiple
}

export const getSelectedProjectParameterValue = (
    parametersList: Partial<ProjectParameter>[],
    currentModifier: string
) => {
    let selectedModifierValues: string = ''
    if (parametersList?.length) {
        const selectedModifierData = parametersList
            .filter((param: Partial<ProjectParameter>) => {
                return param.modifierList?.name === currentModifier
            })[0]
            ?.selectedModifiers?.map(
                (selectedModifierItem) => selectedModifierItem.name
            )
        if (selectedModifierData?.length) {
            selectedModifierValues = selectedModifierData.join(', ')
        }
    }

    return selectedModifierValues
}
